<template>
  <el-tabs style="height: 100px;" type="card" :active-name="activeTabName" @tab-click="handleClick">
    <el-tab-pane label="策略画布" name="flow_chat">
      <flow-chat ref="flow-chat" :strategy="strategy" v-if="activeModule['flow_chat']" />
    </el-tab-pane>
    <el-tab-pane label="组件池" name="components">
      <components ref="components" :strategy="strategy" v-if="activeModule['components']"/>
    </el-tab-pane>
    <el-tab-pane label="版本管理" name="version_manage">
      <version-manage ref="version-manage" :strategy="strategy" v-if="activeModule['version_manage']" @gotoNewVersionStrategy="gotoNewVersionStrategy"/>
    </el-tab-pane>
    <el-tab-pane label="数据运营" name="data_operation">
      <strategy-data-record ref="data-operation" v-if="activeModule['data_operation']"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import FlowChat from '@/views/decisionTree/flow-chat'
import Components from '@/views/component/list'
import VersionManage from '@/views/versionManage/list'
import StrategyDataRecord from '@/views/dataOperation/strategy-data-record'

export default {
  data () {
    return {
      strategy: {},
      activeTabName: 'flow_chat',
      activeModule: {
        'flow_chat': true,
        'components': false,
        'version_manage': false,
        'data_operation': false
      }
    }
  },
  created () {
    this.initStrategy()
  },
  methods: {
    handleClick (tab, event) {
      this.activeTab(tab.name)
      this.initStrategy()
    },
    gotoNewVersionStrategy (code, version) {
      this.$router.push({path: `/strategy-edit/${code}/${version}`})
      this.initStrategy()
    },
    async initStrategy () {
      let strategyCode = this.$route.params.strategyCode
      let strategyVersion = this.$route.params.strategyVersion
      // 请求后端接口
      try {
        let res = await this.$http.get(`/strategy/${strategyCode}/${strategyVersion}`)
        if (res.code !== '200') {
          this.strategy = {}
          this.$message.error('获取策略数据失败')
          return
        }
        this.strategy = res.data
        if (!this.strategy.flowData) {
          this.initFlowChat(this.strategy.id)
        }
      } catch (ex) {
        console.info(ex)
        this.$message.error('获取策略数据失败')
      }
    },
    initFlowChat (strategyId) {
      const startGraphicNodeId = this.generateStr(8)
      const startNode = {
        strategyId: strategyId,
        graphicNodeId: startGraphicNodeId,
        code: 'start',
        name: '开始'
      }
      this.saveNodeData(startNode)
      const endGraphicNodeId = this.generateStr(8)
      const endNode = {
        strategyId: strategyId,
        graphicNodeId: endGraphicNodeId,
        code: 'end',
        name: '结束'
      }
      this.saveNodeData(endNode)
      let flowData = `{"nodes":[{"type":"node","shape":"flow-circle","size":"72*72","color":"#FA8C16","label":"start\\n开始","nodeType":"1","name":"开始","code":"start",
      "x":671,"y":118,"id":"${startGraphicNodeId}","index":0},{"type":"node","shape":"flow-circle","size":"72*72","color":"#FA8C16","label":"end\\n结束",
      "nodeType":"4","name":"结束","code":"end","x":671,"y":666,"id":"${endGraphicNodeId}","index":1}]}`
      this.strategy.flowData = flowData
      this.updateStrategyData(this.strategy)
    },
    async updateStrategyData (data) {
      console.info('updateStrategyData', data)
      // 请求后端服务
      try {
        await this.$http.put(`/strategy`, data)
      } catch (ex) {
        console.info(ex)
      }
    },
    async saveNodeData (node) {
      console.info('saveNodeData', node)
      try {
        await this.$http.post(`/strategy-node/alias`, node)
      } catch (ex) {
        console.info(ex)
      }
    },
    generateStr (len) {
      let text = ''
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      for (let i = 0; i < len; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      return text
    },
    activeTab (tabName) {
      for (let key in this.activeModule) {
        this.activeModule[key] = false
      }
      this.activeModule[tabName] = true
    }
  },
  components: {
    FlowChat,
    Components,
    VersionManage,
    StrategyDataRecord
  }
}
</script>

<style lang="stylus">
  .el-tabs__header {
    margin: 0 0 3px;
  }
</style>



// WEBPACK FOOTER //
// src/views/homepage/strategy-edit.vue